// extracted by mini-css-extract-plugin
export var alertIcon = "_tu-0";